// Lazy wrapper: defers `useContextMenuOptions` work (~15-item array, Redux +
// Recoil + i18n) to right-click time instead of running on every chip render.
import { useEffect } from 'react';
import { CustomContextMenu } from 'components/roster-portal/activity-planning/components';

import useContextMenuOptions from '../../components/ContextMenu/useContextMenuOptions';
import { CHIP_CLASS_NAME } from '../../TimelineView/AppointmentChip/Chip.constants';

interface Props {
  anchorEl: HTMLElement | null;
  eventId: string;
  clientId?: string;
  schedulingLabel?: string;
  isEditable: boolean;
  isAbsent: boolean;
  eventIsOpen: boolean;
  isAssigned: boolean;
  hasAppointmentGrouping: boolean;
  hasEmployee: boolean;
  isCreditable: boolean;
  isCredit: boolean;
  onClose: () => void;
}

export function ChipContextMenu({
  anchorEl,
  eventId,
  clientId,
  schedulingLabel,
  isEditable,
  isAbsent,
  eventIsOpen,
  isAssigned,
  hasAppointmentGrouping,
  hasEmployee,
  isCreditable,
  isCredit,
  onClose
}: Props) {
  'use memo';
  const { options, handleOptionClick } = useContextMenuOptions({
    eventId,
    clientId: clientId ?? '',
    schedulingLabel: schedulingLabel ?? '',
    isEditable,
    isAbsent,
    eventIsOpen,
    isAssigned,
    isProject: false,
    isWorkPlace: false,
    hasAppointmentGrouping,
    hasEmployee,
    isCreditable,
    isCredit
  });

  // Preserve "no options ⇒ no menu": close on next tick; empty render below
  // means nothing paints, so no flicker.
  const isEmpty = options.length === 0;
  useEffect(() => {
    if (isEmpty) onClose();
  }, [isEmpty, onClose]);

  if (isEmpty) return null;

  return (
    <CustomContextMenu
      anchorEl={anchorEl}
      targetElClassName={CHIP_CLASS_NAME}
      open
      options={options}
      onOptionClick={handleOptionClick}
      onClose={onClose}
    />
  );
}
